export default {
  infoBlockTitle: {
    id: 'checkout_bouygues_magic_link_layout_info_block_title',
    defaultMessage:
      'La souscription à votre forfait Bouygues Telecom est toujours en cours.',
  },
  infoBlockContent: {
    id: 'checkout_bouygues_magic_link_layout_info_block_content',
    defaultMessage:
      'Pour tout changement, appelez le service client Bouygues Telecom par téléphone au 1064, du lundi au samedi de 8h à 20h.',
  },
  infoBlockCta: {
    id: 'checkout_bouygues_magic_link_layout_info_block_cta',
    defaultMessage: 'Contacter Bouygues Telecom',
  },
}
